import { React, useState, useEffect } from "react";
import Footer2 from "./Footer2";
import "./Button.css";

import { FaCheckCircle } from "react-icons/fa";
// import assignmentCheck from "@iconify-icons/zmdi/assignment-check";
import { useNavigate } from "react-router-dom";
import StorageService from "../services/storage.service";

import secureLocalStorage from "react-secure-storage";
import { Helmet } from "react-helmet";

function TestOurTech_thankyou(props) {
  const TITLE = process.env.REACT_APP_API_SITE_TITLE + " | Thank You";
  const [website, setWebsite] = useState(window.location.href);
  // const [signoutTime, setSignoutTime] = useState(180000);
  const [signoutTime, setSignoutTime] = useState(900000);
  const navigate = useNavigate();
  StorageService.destroyThankStorage();

  useEffect(() => {
    function timeout() {
      setTimeout(function () {
        localStorage.setItem("returnpage", false);
        localStorage.removeItem("RegisterForm");
        window.location.replace("/register");
        return false;
      }, signoutTime);
    }

    timeout();
  }, [signoutTime]);

  useEffect(() => {
    //FIXME
    const isRegister = localStorage.getItem("isRegister");
    if (
      isRegister === "false" ||
      isRegister === null ||
      isRegister === undefined
    ) {
      navigate("/register");
    }
    var registerform = secureLocalStorage.getItem("registerform");
    var RegisterObject = registerform ? JSON.parse(registerform) : false;
    if (typeof RegisterObject === "boolean") {
      navigate("/register");
    } else {
      // let showroom = RegisterObject.showroom ? RegisterObject.showroom : false;
    }
  }, []);
  const myDestory = () => {
    localStorage.removeItem("return_page", false);
    localStorage.removeItem("isRegister");
    secureLocalStorage.removeItem("registerform");
    navigate("/register");
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="container-fluid">
        <div className="white-box thank">
          <h1 className="text-center">Thank You! </h1>
          {/* <Icon icon={assignmentCheck} /> */}
          <FaCheckCircle />
          <p>
            You will receive your Hawaii Dream Vacation Giveaway. For further
            information please call{" "}
            <a href={"tel:" + process.env.REACT_APP_DESC_CONTACTUS + '"'}>
              <strong>{process.env.REACT_APP_DESC_CONTACTUS}</strong>
            </a>{" "}
            or email us at{" "}
            <a href={"mailto:" + process.env.REACT_APP_DESC_CUSTOMERCARE + '"'}>
              <strong>{process.env.REACT_APP_DESC_CUSTOMERCARE}</strong>
            </a>{" "}
            and one of our customer service representatives will be happy to
            assist you.
          </p>
          <a
            href="javascript:void(0)"
            onClick={() => myDestory()}
            id="Thanku_Buttons"
            className="btn btn-md btn-primary2"
          >
            Go Back
          </a>
        </div>
      </div>
      <Footer2 />
    </>
  );
}
export default TestOurTech_thankyou;
